(() => {
  const params = new URLSearchParams(location.search);
  const token = params.get('ts_bundle_editor') || document.querySelector('meta[name="ts-bundle-token"]')?.content || window.name;
  if (!token || window.parent === window || String(window.Shopify?.theme?.id || '') !== '188970434781') return;
  const ar = document.documentElement.lang.startsWith('ar');
  const origin = new URL(document.baseURI).origin;
  const send = (type, detail = {}) => parent.postMessage({source:'2seasons-zepto',token,type,...detail},origin);
  const saveLabel = document.querySelector('meta[name="ts-save-label"]')?.content || (ar ? 'حفظ التخصيص والعودة للطقم' : 'Save personalisation');
  let opened = false, installed = false, busy = false;
  document.documentElement.classList.add('ts-bundle-editor');
  const style = document.createElement('style');
  style.textContent = 'html.ts-bundle-editor body{background:#fff!important;overflow:hidden!important}html.ts-bundle-editor body> :not(.pplr_crop-modal):not(script):not(style){visibility:hidden!important}html.ts-bundle-editor .pplr_crop-modal{background:#fff!important;position:fixed!important;inset:0!important;padding:0!important;overflow:auto!important}html.ts-bundle-editor .pplr-popup{top:0!important;margin:0!important;left:0!important;width:100%!important;max-width:none!important;box-shadow:none!important;border:0!important}html.ts-bundle-editor .pplr_ex_button .c_h_m{display:none!important}html.ts-bundle-editor .pplr-main{padding:16px!important}html.ts-bundle-editor .pplr_ex_button{background:#fff!important;padding-bottom:16px!important}html.ts-bundle-editor .pplr_ex_button button{font-family:inherit!important;font-size:14px!important;padding:14px 20px!important}html.ts-bundle-editor .pplr-p-right{overscroll-behavior:contain}';
  if(document.querySelector('meta[name="ts-save-label"]'))style.textContent+='html.ts-bundle-editor .pplr-popup{overflow:visible!important}html.ts-bundle-editor .pplr-p-right{min-height:0!important;max-height:calc(100dvh - 155px)!important}html.ts-bundle-editor .pplr_ex_button{position:fixed!important;bottom:0!important;left:0!important;right:0!important;width:100%!important;padding:8px 20px!important;box-sizing:border-box!important;z-index:999999!important;border-top:1px solid #eee!important}html.ts-bundle-editor .pplr_ex_inner{height:auto!important;min-height:0!important}';
  document.head.append(style);
  if(document.querySelector('meta[name="ts-save-label"]'))style.textContent+='@media(min-width:650px){html.ts-bundle-editor .pplr-main>.pplr_form{display:grid!important;width:100%!important;grid-template-columns:minmax(0,1fr) minmax(0,1fr)!important;gap:20px!important;align-items:start!important}html.ts-bundle-editor .pplr-p-left,html.ts-bundle-editor .pplr-p-right{width:100%!important;float:none!important;margin:0!important}html.ts-bundle-editor .pplr-p-right{max-height:calc(100dvh - 85px)!important;min-height:160px!important}}@media(max-width:649px){html.ts-bundle-editor .pplr-p-right{max-height:none!important;min-height:220px!important;overflow:visible!important}html.ts-bundle-editor .pplr-main{padding-bottom:100px!important}}';
  function reset() {
    busy = false;
    if (typeof window.pplr_reset_cart === 'function') window.pplr_reset_cart();
    document.querySelectorAll('.pplr_crop-modal .p_a_t_c').forEach(button => {button.textContent=saveLabel;button.disabled=false;});
  }
  async function capture(data) {
    if (busy) return;
    busy = true;
    try {
      const fd = data?.fd || data;
      if (!(fd instanceof FormData) || !Number(fd.get('id'))) throw Error('Invalid personalisation');
      
      const variantResponse = await fetch((window.Shopify.routes?.root || '/')+'variants/'+Number(fd.get('id'))+'.js',{cache:'no-store'});
      if (!variantResponse.ok) throw Error('Variant unavailable');
      const variant = await variantResponse.json();
      if (!Number.isFinite(variant.price)) throw Error('Price unavailable');
      window.twoSeasonsFees?.capture(fd,variant.price);
      const fields=Array.from(fd.entries()).filter(([name])=>name==='id'||name==='selling_plan'||/^properties\[.+\]$/.test(name));
      send('saved',{fields,price:variant.price,variant:Number(fd.get('id'))});
      reset();
    } catch {
      reset();send('error');
    }
  }
  function install() {
    if (!installed && window.jQuery?.ajax) {
      const ajax = window.jQuery.ajax;
      window.jQuery.ajax = function(url, options) {
        const settings = typeof url === 'object' ? url : {...options,url};
        const path = new URL(settings.url || document.baseURI,origin).pathname;
        if (/\/(?:[a-z]{2}\/)?cart\/add(?:\.js)?\/?$/.test(path) && String(settings.method || settings.type || 'GET').toUpperCase()==='POST') {
          capture(settings.data);
          return window.jQuery.Deferred().resolve().promise();
        }
        if (/\/cart\/(?:change|update|clear)(?:\.js)?/.test(path)) return window.jQuery.Deferred().reject().promise();
        return ajax.apply(this,arguments);
      };
      installed = true;
    }
    const button = document.querySelector('.pplr-c-button');
    if (installed && button && !opened) {
      opened = true;button.click();send('ready');
    }
    document.querySelectorAll('.pplr_crop-modal .p_a_t_c').forEach(button=>{if(!button.disabled && button.textContent!==saveLabel)button.textContent=saveLabel;});
    if(ar){
      const translations={'Embossing':'الحروف والاسم','Stickers':'الستيكرات والصور','Initials/Name':'الحروف أو الاسم','Choose Initials/Name Color':'لون الحروف أو الاسم','Show Tags':'إضافة صور المدن','Button':'طريقة التنفيذ','Print':'طباعة','Painting':'رسم يدوي','Image Choices':'اختيار الصور'};
      document.querySelectorAll('.pplr_tab_index,.pplrlabel,.pplr-drop-item,.pplr-character-count').forEach(element=>{
        const walker=document.createTreeWalker(element,NodeFilter.SHOW_TEXT);
        let node;while(node=walker.nextNode()){
          const text=node.textContent.trim();
          if(translations[text])node.textContent=node.textContent.replace(text,translations[text]);
          if(/^Select Tag [1-4]\/4$/.test(text))node.textContent='صورة '+text.match(/[1-4]/)[0]+' من 4';
          if(/^\d+ characters left$/.test(text))node.textContent=text.match(/^\d+/)[0]+' أحرف متبقية';
        }
      });
    }
  }
  window.addEventListener('pplrAppInitiated',install);
  window.addEventListener('message',event=>{
    if(event.origin!==origin || event.source!==parent || event.data?.token!==token)return;
    if(event.data.type==='open')install();
  });
  const changed=event=>{if(event.target.closest('.pplr_crop-modal')&&(event.target.matches('input,select,textarea')||event.target.closest('.pplrimage,.pplrColor,.pplr-drop-item')))send('dirty');};
  document.addEventListener('input',changed,true);document.addEventListener('change',changed,true);document.addEventListener('click',changed,true);
  document.addEventListener('submit',event=>event.preventDefault(),true);
  const timer=setInterval(install,150);
  setTimeout(()=>{clearInterval(timer);if(!opened)send('error');},45000);
})();




